// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-docs-tsx": () => import("./../../../src/pages/docs.tsx" /* webpackChunkName: "component---src-pages-docs-tsx" */),
  "component---src-pages-events-tsx": () => import("./../../../src/pages/events.tsx" /* webpackChunkName: "component---src-pages-events-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-templates-category-redirect-tsx": () => import("./../../../src/templates/CategoryRedirect.tsx" /* webpackChunkName: "component---src-templates-category-redirect-tsx" */),
  "component---src-templates-document-tsx": () => import("./../../../src/templates/Document.tsx" /* webpackChunkName: "component---src-templates-document-tsx" */)
}

